import { createModule } from '../../createModule';
export const createExternalAPI = createModule(({ http }) => {
    return {
        client: {
            getInstruments: async () => {
                const res = await http.get('/v2/external/client/instruments');
                return res;
            },
            getInstrumentsId: async (params) => {
                const res = await http.get(`/v2/external/client/instruments/${params.client_id}`);
                return res;
            },
            getDetails: async (params) => {
                const res = await http.get(`/v2/external/client/instrument/${params.isin}`);
                return res;
            },
            getPricingHistory: async (params) => {
                const res = await http.get(`/v2/external/client/instrument/price_history/${params.isin}`);
                return res;
            },
            getTrades: async ({ client_id, st_dt, ed_dt }) => {
                const res = await http.get(`/v2/external/client/trades/${client_id}`, {
                    params: { st_dt, ed_dt },
                });
                return res;
            },
        },
    };
});
